import { AtendimentosListSearchComponent } from './AtendimentosListSearchComponent'

export const AtendimentosListHeader = () => {
  return (
    <div className='border-0 pt-6'>
      <AtendimentosListSearchComponent />
      {/* <div className='container mt-3'>
        <SelectionHeaderContainer selected={selected}>
          {selected.length > 0 ? <UsersListGrouping /> : <UsersListToolbar />}
        </SelectionHeaderContainer>
      </div> */}
    </div>
  )
}
